import { useState } from "react"

const usePagination = () => {
  const [pagination, setPagination] = useState({
    pageSize: 20,
    pageIndex: 0,
  })
  const { pageSize, pageIndex } = pagination

  return {
    limit: pageSize,
    onPaginationChange: setPagination,
    pagination,
    page: pageIndex + 1,
  }
}

export default usePagination
